import React from 'react'

class CustomItemModalBox extends React.Component {
    constructor(props) {
      super(props)
      if (this.props.editMode) {
        this._prepareData(this.props.item.name, this.props.item.date, this.props.item.reminder_days, this.props.item.summary);
      } else {
        this._prepareData('', '', 0, '');
      }
    }

    _prepareData(name, date, days, summary){
      this.state = {
        data: {
          name: name,
          timeline_event_date: date,
          reminder_days: days,
          summary: summary,
        }
      }
    }

    componentDidMount() {
      const _this = this;
      return $(".datepicker").datepicker({
        format: gon.default_date_format_string,
        clearBtn : true
      }).on('changeDate', function(e) {
        $(this).datepicker('hide');
        const formattedDate = $(e.target).val();
        let date = '';
        if (formattedDate) {
          date = moment(formattedDate, gon.default_date_format_string.toUpperCase()).format('YYYY-MM-DD');
        }
        const updated_data = _this.state.data;
        if (updated_data[`${this.name}`] !== date) {
          updated_data[`${this.name}`] = date;
          return _this.setState({data: updated_data});
        }
      }).on('show', date => $('.datepicker.datepicker-dropdown').addClass('notranslate')).on('hide.bs.modal', e => $('body').removeClass('modal-open')).keydown(false);
    }

    timeline_date() {
      const date = this.state.data.timeline_event_date;
      return date && moment(date).format(gon.default_date_format_string.toUpperCase());
    }

    handleClose() {
      return this.props.handleCustomTaskClose('');
    }

    handleChange(e){
      const updated_data = this.state.data;
      updated_data[`${e.target.name}`] = e.target.value;
      return this.setState({data: updated_data});
    }

    handleDateChange() {}

    openDatepicker(e) {
      const datepicker = $(e.target).closest('.input-group').find('.datepicker');
      if (!datepicker.is(':disabled')) {
        return datepicker.datepicker('show');
      }
    }

    handleSubmit(e){
      e.preventDefault();
      if (this.props.editMode) {
        $.ajax({
          type: 'PATCH',
          data: { timeline_item: this.state.data },
          url: `/timeline_items/${this.props.item.timeline_id}`,
          success: response => {
            if (response.id) {
              this.props.handleCustomTaskChange(response);
              this.handleClose();
              toastr.success('Task updated successfully');
            } else {
              toastr.error('Task not updated');
            }
          }
        });

      } else {
        $.post('/timeline_items', { timeline_item: this.state.data }, response => {
          if (response.data.id) {
            this.props.handleNewTaskItem(response);
            this.handleClose();
            toastr.success('Custom task added successfully');
          } else {
            toastr.error(response.data);
          }
        });
      }
    }

    backdrop() {
      return <div className='modal-backdrop in'></div>
    }

    renderNameInput() {
      if(this.props.editMode && !this.props.item.custom_task) {
        return(
          <p className='uneditable-p'>
            {this.state.data.name}
          </p>
        );
      } else {
        return (
          <input
            name='name'
            type='text'
            className='form-control'
            value={this.state.data.name}
            required={true}
            onChange={this.handleChange.bind(this)}
          />
        );
      }
    }

    renderCalendarInput() {
      if(this.props.editMode && (this.props.item.event_type === 'Essential')) {
        return (
          <p className='uneditable-p'>
            {moment(this.props.item.date).format(gon.default_date_format_string.toUpperCase())}
          </p>
        );
      } else {
        return (
          <div className='input-group'>
            <input className="form-control datepicker"
              type='text'
              name='timeline_event_date'
              value={this.timeline_date()}
              onChange={this.handleDateChange.bind(this)}
              required={true}
            />
            <span className='input-group-addon btn-darkgray' onClick={this.openDatepicker.bind(this)}>
              <span className='fa fa-calendar-o fa-lg'/>
            </span>
          </div>
        );
      }
    }

    renderTextAreaInput() {
      if(this.props.editMode && !this.props.item.custom_task){
        return(<p className='uneditable-p'> {this.state.data.summary} </p>);
      } else {
        return (
          <textarea
            rows='5'
            name='summary'
            className='form-control'
            value={this.state.data.summary}
            onChange={this.handleChange.bind(this)}
          />
        );
      }
    }

    renderReminderDays() {
      return (
        <div className='form-group clearfix'>
          <label className='col-sm-3'> Remind me </label>
          <div className='col-sm-2 no-padding reminder_days'>
            <input className='form-control' type='text' name='reminder_days' value={this.state.data.reminder_days} onChange={this.handleChange.bind(this)}/>
          </div>
          <label className='col-sm-5'> days before this task is due</label>
        </div>
      );
    }

    modal() {
      return (
        <div className='modal in' tabIndex='-1' role='dialog' aria-hidden={false} ref='modal' style={{ display: 'block' }}>
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <div className='close-button' onClick={this.handleClose.bind(this)}>
                  <span> Close</span>
                  <span className='fa fa-times'/>
                </div>
              </div>
              <div className='modal-body'>
                <div className='row'>
                  <form onSubmit={this.handleSubmit.bind(this)}>
                    <div className='col-sm-12'>
                      <div className='form-group clearfix'>
                        <label className='col-sm-3'> Task name </label>
                        <div className='col-sm-9 no-padding'>
                          { this.renderNameInput() }
                        </div>
                      </div>
                      <div className='form-group clearfix'>
                        <label className='col-sm-3'> Task Due Date </label>
                        <div className='col-sm-4 no-padding'>
                          { this.renderCalendarInput() }
                        </div>
                      </div>
                      { !this.props.disabledTaskEmailNotifications && this.renderReminderDays() }
                      <div className='form-group clearfix'>
                        <label className='col-sm-3'> Description </label>
                        <div className='col-sm-9 no-padding'>
                          { this.renderTextAreaInput() }
                        </div>
                      </div>
                      <div className='form-group clearfix'>
                        <div className='col-sm-4 col-sm-offset-3 no-padding confirmation-links'>
                          <button type='submit' className='btn btn-save'> Save </button>
                          <button className='btn btn-default' onClick={this.handleClose.bind(this)}> Cancel</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        );
    }

    render() {
      return (
        <div className='custom-task-modal'>
          {this.backdrop()}
          {this.modal()}
        </div>
      );
    }
}

export default CustomItemModalBox
